<script>
    import {API_URL} from "../../../env";
    import {addAlert} from "../../js/alert";

    let agreement = false
    let name = ""
    let email = ""
    let message = ""

    let validity = {
        name: false,
        email: false,
        message: false,
        agreement: false
    }

    let isSending = false

    async function submitForm(e) {
        if (isSending) return;
        isSending = true

        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        let ret = false

        validity.name = false
        validity.email = false
        validity.message = false
        validity.agreement = false

        if (!agreement) {
            addAlert("danger", "Chyba", "Musíte súhlasiť so spracovaním osobných údajov.")
            ret = true
            validity.agreement = true
            isSending = false;
        }
/*        if (name.length === 0) {
            validity.name = true
            ret = true
        }*/
        if (!emailRegex.test(email)) {
            validity.email = true
            ret = true
        }
        if (message.length === 0) {
            validity.message = true
            ret = true
        }

        if (ret && agreement) {
            isSending = false
            return addAlert("danger", "Chyba", "Formulár nie je správne vyplnený.");
        }

        // if (!agreement || name.length === 0 || !email.includes('@') || !email.includes('.') || message.length === 0) return console.error('Form incomplete!');

        let body = {
            name,
            email,
            message
        }
        
        const res = await fetch(API_URL + '/forms/sendContactForm', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            console.error(await res.json())
            addAlert("danger", "Chyba", "Odoslanie správy sa nepodarilo. Skúste to prosím znova.")
            return isSending = false
        }

        name = ""
        email = ""
        message = ""
        agreement = false
        isSending = false
    }

    function getButtonIcon(isSending) {
        if (isSending) {
            return "fa-spin fa-spinner-third"
        }
        return "fa-envelope"
    }
</script>

<form on:submit|preventDefault={submitForm}>
    <div class="row">
        <div class="col-lg-6 mb-4">
            <div class="input-group">
                <label for="fullname">Meno a priezvisko</label>
                <input class:unfilled={validity.name} type="text" placeholder="Meno" id="fullname" bind:value={name}>
            </div>
        </div>
        <div class="col-lg-6 mb-4">
            <div class="input-group">
                <label for="email">E-mail</label>
                <input class:unfilled={validity.email} type="email" placeholder="E-mail" id="email" bind:value={email}>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-4">
            <div class="input-group">
                <label for="email">Správa</label>
                <textarea class:unfilled={validity.message} placeholder="Správa..." bind:value={message}></textarea>
            </div>
        </div>
    </div>
    <div class="form-footer">
        <label>
            <input class="checkbox_animated" type="checkbox" bind:checked={agreement} class:unfilled={validity.agreement}>
            Súhlasím so spracovaním <a target="_blank" href="#/ochrana-osobnych-udajov">osobných údajov</a>
        </label>
        <button type="submit" class="btn btn-primary"><i class="fas {getButtonIcon(isSending)} mr-2"></i>Odoslať</button>
    </div>
</form>

<style>
    textarea {
        min-height: 15rem;
        max-height: 25rem;
        resize: vertical;
        transition: none;
    }
    .form-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .form-footer label {
        line-height: 2rem;
        user-select: none;
        cursor: pointer;
    }
</style>